export default __webpack_public_path__ + "static/media/closet5-after1.ef3de199.jpg";